module.exports = __webpack_public_path__ + "media/images/icons/wizard/progress/bottom-active-381a74855a51118bb63a3486b33d3b85.svg";